import { JsonRpcModule } from '../../jrpc/module';

export class WebviewModule extends JsonRpcModule {
    async openExternalUrlsInBrowser() {
        return this.channel.call("WebView.OpenExternalUrlsInBrowser", []);
    }

   async excludeUrlFromOpeningExternally(url: string) {
        return this.channel.call("WebView.ExcludeUrlFromOpeningExternally", [url]);
    }

    async openUrlExternally(url: string) {
        return this.channel.call("WebView.OpenUrlExternally", [url]);
    }
}
